import React from "react";
import "../styles/typography.css";
import styles from "../styles/ChatClassification.module.css";

interface ChatHeaderProps {
  onMinimize?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onMinimize }) => {
  return (
    <header className={styles.chatHeader}>
      <div className={styles.headerLeft}>
        <img
          src="/ChatWidget/images/chatbot_design_grafico.svg"
          alt="Chatbot Design"
          className={styles.headerIcon}
          onError={(e) => {
            // fallback caso o caminho relativo falhe
            (e.currentTarget as HTMLImageElement).src =
              "/ChatWidget/images/chatbot_design_grafico.svg";
          }}
        />
        <h2 className={styles.headerTitle}>Assistente Virtual</h2>
      </div>

      {onMinimize && (
        <button
          className={styles.minimizeButton}
          onClick={onMinimize}
          aria-label="Minimizar chat"
          title="Minimizar"
        >
          &#x2212;
        </button>
      )}
    </header>
  );
};

export default ChatHeader;
